module.exports = __webpack_public_path__ + "static/02-b26c1512fd513bd845394052d17563dd.jpg";